module.exports = __webpack_public_path__ + "static/media/A15.17f017ba.jpg";